import { render, staticRenderFns } from "./IFrame.vue?vue&type=template&id=5422cf86"
import script from "./IFrame.vue?vue&type=script&lang=js"
export * from "./IFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports